import { EditOutlined , PrinterOutlined } from "@ant-design/icons";
import { Space, Table, Drawer, Button } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import CustomTableSearch from "../common/CustomTableSearch";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";





const TaxInvoiceListView = (props) => {
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    useEffect(()=>{
        setFilteredSearchList(props.taxInvoiceList);
    },[props.taxInvoiceList]);

    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = props.taxInvoiceList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
      }

    const columns = [
        {
            title: 'Invoice No',
            dataIndex: 'invoice_number',
            key: 'invoice_number',


        },
        {
            title: 'Invoice Date',
            dataIndex: 'invoice_date',
            key: 'invoice_date',


        },
        {
            title: 'Customer',
            dataIndex: 'customer_name',
            key: 'customer_name',


        },
        {
            title: 'Taxable Amt.',
            dataIndex: 'total_taxable_amount',
            key: 'total_taxable_amount',
            align:'right',
            render:(e,data) => {
                return <>{commonUtility.sanitizeValue(data.total_taxable_amount).toFixed(2)}</>
            }
        },
        {
            title: 'Gst Amt.',
            dataIndex: 'total_gst_amount',
            key: 'total_gst_amount',
            align:'right',
            render:(e,data) => {
                //return <>{data?.total_gst_amount.toFixed(2)}</>
                return <>{commonUtility.sanitizeValue(data.total_gst_amount).toFixed(2)}</>
            }
        },
        {
            title: 'Round off',
            dataIndex: 'round_off_amount',
            key: 'round_off_amount',
            align:'right',
            render:(e,data) => {
                //return <>{data?.round_off_amount.toFixed(2)}</>\
                return <>{commonUtility.sanitizeValue(data.round_off_amount).toFixed(2)}</>
            }
        },
        {
            title: 'Net Amount',
            dataIndex: 'net_payble_amount',
            key: 'net_payble_amount',
            align:'right',
            render:(e,data) => {
                //return <>{data?.net_payble_amount.toFixed(2)}</>
                return <>{commonUtility.sanitizeValue(data.net_payble_amount).toFixed(2)}</>
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (selectedObj) => (
                <Space size="middle">
                    <Link to={`/taxinvoice/entry/${selectedObj.salebill_id}`} >
                        <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
                    </Link>

                    <a href={`${PRINT_BASE_URL}taxinvoice/print/${selectedObj.salebill_id}`} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
                    </a>
                </Space>
            ),
        },
    ];




    return (
        <>

            <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} />
            <Table columns={columns} rowKey='salebill_id' dataSource={filteredSearchList} />
        </>
    );
};

export default TaxInvoiceListView